import { render, staticRenderFns } from "./CatalogTile.vue?vue&type=template&id=3c608ab2&scoped=true&"
import script from "./CatalogTile.vue?vue&type=script&lang=ts&"
export * from "./CatalogTile.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogTile.vue?vue&type=style&index=0&id=3c608ab2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c608ab2",
  null
  
)

export default component.exports